import {
    CREATE_PROCESS_ADD_ON_REQUEST_DK,
    CREATE_PROCESS_ADD_ON_SUCCESS_DK,
    CREATE_PROCESS_ADD_ON_FAILURE_DK,
    DELETE_PROCESS_ADD_ON_REQUEST_DK,
    DELETE_PROCESS_ADD_ON_SUCCESS_DK,
    DELETE_PROCESS_ADD_ON_FAILURE_DK,
    FETCH_SINGLE_PROCESS_ADD_ON_REQUEST_DK,
    FETCH_SINGLE_PROCESS_ADD_ON_SUCCESS_DK,
    FETCH_SINGLE_PROCESS_ADD_ON_FAILURE_DK,
    FETCH_PROCESS_ADD_ON_REQUEST_DK,
    FETCH_PROCESS_ADD_ON_SUCCESS_DK,
    FETCH_PROCESS_ADD_ON_FAILURE_DK,
    UPDATE_PROCESS_ADD_ON_REQUEST_DK,
    UPDATE_PROCESS_ADD_ON_SUCCESS_DK,
    UPDATE_PROCESS_ADD_ON_FAILURE_DK,
    RESET_PROCESS_ADD_ON_INFO_DK,
    CREATE_PROCESS_ADD_ON_FORM_DK,
    UPDATE_PROCESS_ADD_ON_FORM_DK
} from './processAddOn.actionsType';

export const PROCESS_ADD_ON_DK = 'processAddOnDK';

let initialState = {
    loading: false,
    processAddOnList: [],
    processAddOnform: {},
    selectedState: {},
    errorMessage: ''
};

export let processAddOnDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PROCESS_ADD_ON_REQUEST_DK:
        case CREATE_PROCESS_ADD_ON_REQUEST_DK:
        case UPDATE_PROCESS_ADD_ON_REQUEST_DK:
        case FETCH_SINGLE_PROCESS_ADD_ON_REQUEST_DK:
        case DELETE_PROCESS_ADD_ON_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROCESS_ADD_ON_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAddOnList: updatePayload
            };
        case CREATE_PROCESS_ADD_ON_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAddOnform: {}
            };
        case UPDATE_PROCESS_ADD_ON_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAddOnform: {}
            };
        case FETCH_SINGLE_PROCESS_ADD_ON_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAddOnform: updatePayload
            };
        case DELETE_PROCESS_ADD_ON_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                processAddOnform: {}
            };
        case RESET_PROCESS_ADD_ON_INFO_DK:
            return {
                ...state,
                processAddOnform: {}
            };
        case CREATE_PROCESS_ADD_ON_FORM_DK:
        case UPDATE_PROCESS_ADD_ON_FORM_DK:
            return {
                ...state,
                loading: false,
                processAddOnform: {
                    ...state.processAddOnform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PROCESS_ADD_ON_FAILURE_DK:
        case CREATE_PROCESS_ADD_ON_FAILURE_DK:
        case UPDATE_PROCESS_ADD_ON_FAILURE_DK:
        case FETCH_SINGLE_PROCESS_ADD_ON_FAILURE_DK:
        case DELETE_PROCESS_ADD_ON_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
